/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable consistent-return */
import React, { FunctionComponent, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useFormik } from 'formik';
import { useNavigate } from 'react-router-dom';
import {
  selectInterventionsChecklistValue,
  calculatorActions,
  selectInterventionsValue,
  selectServiceDataForm,
  selectEmergencyDepartment,
  selectReportName,
  selectState,
  selectTouched
} from '../../../../redux/calculatorSlice';
import {
  InterventionsChecklistForm,
  ImmunizationsForm,
  IImmunizations,
  InterventionsCommonForm
} from '../../../../interfaces/interventions.interface';
import { CalculatorEnum } from '../../../../interfaces/calculator.interface';
import { FormValidations, StringFormatter, Constants } from '../../../../utils';
import {
  InterventionHeader,
  InterventionBody,
  InterventionContainer,
  InterventionFieldNoteDialog
} from '../Intervention';
import { Immunizations as ImmunizationsClass } from '../../../../calculations';
import useDebounceEffect from '../../../../hooks/useDebounceEffect';
import { paths } from '../../..';
import ImmunizationInterventionFooter from './ImmunizationInterventionFooter';
import ImmunizationInterventionCalculation from './ImmunizationInterventionCalculation';
import { useLocation } from 'react-router';

const { DIALOG_MODES } = Constants,

 Immunizations: FunctionComponent = () => {

  const dispatch = useDispatch(),
   navigate = useNavigate(),
   location = useLocation(),
   switchValue = useSelector(
    selectInterventionsChecklistValue(InterventionsChecklistForm.Immunizations)
  ),
   immunizationsData = useSelector(
    selectInterventionsValue(CalculatorEnum.Immunizations)
  ),

   serviceData = useSelector(selectServiceDataForm),

   reportName = useSelector(selectReportName),
   selectedState = useSelector(selectState),

   emergencyDepartment = useSelector(selectEmergencyDepartment),
   touched = useSelector(selectTouched),

   [reinitialize, setReinitialize] = useState(true),
   [noteName, setNoteName] = useState<string>(''),
   [noteAction, setNoteAction] = useState<'add' | 'edit' | 'delete'>(DIALOG_MODES.ADD),
   [isNoteDialogOpen, setIsNoteDialogOpen] = useState(false),

   fields = [
    {
      text: `Number of caregivers who discussed a need for flu vaccines for their Medicaid/CHIP-enrolled children with a HS Specialist and/or were assisted in pursuing the flu vaccine
      `,
      id: ImmunizationsForm.NeedForFluVaccinations,
      showError: true,
    }
  ],

   earlyChildhoodFields = [
    {
      text: `Number of caregivers who discussed early childhood vaccinations for Medicaid/CHIP-enrolled children ages 0-18 months with a HS Specialist and/or were assisted in pursuing the vaccines
      `,
      id: ImmunizationsForm.NumberOfCaregiversDiscussingECVWithHSS,
      showError: true,
    }
  ],

   onSubmit = (values: IImmunizations) => {
    if (touched) {

      dispatch(
        calculatorActions.saveReport({
          reportName,
          update: true,
          navigate:navigate,
          pathname:location.pathname
        }));

}

    navigate(
      StringFormatter.replaceWithReportName(
        reportName,
        paths.interventionsDiapers
      )
    );

};

  useEffect(() => {

    if (switchValue) {

      const timeout = setTimeout(() => {

        setReinitialize(false);

}, 250);

      return () => {

        clearTimeout(timeout);

};

}

}, [switchValue]);

  const form = useFormik({
    initialValues: {
      ...immunizationsData,
      [InterventionsCommonForm.LongTermSavingsLow]:
        immunizationsData[InterventionsCommonForm.LongTermSavingsLow] || '0',
      [InterventionsCommonForm.LongTermSavingsHigh]:
        immunizationsData[InterventionsCommonForm.LongTermSavingsHigh] || '0',
    },
    onSubmit,
    validationSchema:
      switchValue &&
      FormValidations.intervention({
        [ImmunizationsForm.NeedForFluVaccinations]:
          FormValidations.required('')
            .test(
              FormValidations.getInterventionNumberOfChildsConfig(
                ImmunizationsForm.NeedForFluVaccinations,
                serviceData.csInput3
              )
            ),

        [ImmunizationsForm.NumberOfCaregiversDiscussingECVWithHSS]:
          FormValidations.required('')
            .test(
              FormValidations.getInterventionNumberOfChildsConfig(
                ImmunizationsForm.NumberOfCaregiversDiscussingECVWithHSS,
                serviceData.csInput3
              )
            ),

            [InterventionsCommonForm.LowEstimate]:
              FormValidations.maxPercentageRequired(''),

            [InterventionsCommonForm.HighEstimate]:
              FormValidations.maxPercentageRequired('')
                .test(
                  'highEstimateValidation',
                  'The high estimate value must be bigger than the low estimate',
                   function test(this: any, value: any) {

                if (!value) return false;

                return (
                  +value >
                  +(this.parent[
                    InterventionsCommonForm.LowEstimate
                  ] || '')
                );
              }
            ),
        [InterventionsCommonForm.LongTermLowEstimate]:
          FormValidations.maxPercentageRequired(''),

        [InterventionsCommonForm.LongTermHighEstimate]:
          FormValidations.maxPercentageRequired('')
            .test(
              'highEstimateValidation',
              'The high estimate value must be bigger than the low estimate',
              function test(this: any, value: any) {

                if (!value) return false;

                return (
                  +value >
                  +(this.parent[
                    InterventionsCommonForm.LongTermLowEstimate
                  ] || '')
                );
              }
            ),
      }),
    validateOnBlur: false,
    validateOnChange: false,
    enableReinitialize: reinitialize || !switchValue,
  });

  useEffect(() => {

    if (!switchValue) {

      form.resetForm();
      dispatch(
        calculatorActions.clearInterventionData(CalculatorEnum.Immunizations)
      );

}

}, [switchValue]);

  useDebounceEffect(() => {

    const hasBeenEdited = Object.keys(form.values).some(
      (key) => !!form.values[key]
    );
    if (!form.dirty && !hasBeenEdited) return;
    /** Calculations happen */
    const immunizations = new ImmunizationsClass({
      state: selectedState,
      serviceData,
      emergencyDepartment,
      lowEstimatedSlider: +form.values[InterventionsCommonForm.LowEstimate],
      highEstimatedSlider: +form.values[InterventionsCommonForm.HighEstimate],
      longTermLowEstimatedSlider: +form.values[InterventionsCommonForm.LongTermLowEstimate],
      longTermHighEstimatedSlider: +form.values[InterventionsCommonForm.LongTermHighEstimate],
      needForFluVaccinations: +form.values[ImmunizationsForm.NeedForFluVaccinations],
      numberOfCaregiversDiscussingECVWithHSS: +form.values[ImmunizationsForm.NumberOfCaregiversDiscussingECVWithHSS],
    }),

     savingsLow = immunizations.immunizationsEstimatedSavingsLow(),
     savingsHigh = immunizations.immunizationsEstimatedSavingsHigh(),

     longTermSavingsLow = immunizations.immunizationsEstimatedLongTermSavingsLow(),
     longTermSavingsHigh = immunizations.immunizationsEstimatedLongTermSavingsHigh();

    if (
      +form.values[InterventionsCommonForm.SavingsLow] !== savingsLow ||
      +form.values[InterventionsCommonForm.SavingsHigh] !== savingsHigh ||
      +form.values[InterventionsCommonForm.LongTermSavingsLow] !== longTermSavingsLow ||
      +form.values[InterventionsCommonForm.LongTermSavingsHigh] !== longTermSavingsHigh
    ) {

      form.setValues({
        ...form.values,
        [InterventionsCommonForm.SavingsLow]: savingsLow.toString(),
        [InterventionsCommonForm.SavingsHigh]: savingsHigh.toString(),
        [InterventionsCommonForm.LongTermSavingsLow]: longTermSavingsLow.toString(),
        [InterventionsCommonForm.LongTermSavingsHigh]: longTermSavingsHigh.toString(),
      });

}

    form.validateForm().then((errors) => {

      const isValid = !Object.keys(errors).length;

      if (form.dirty) {

        dispatch(
          calculatorActions.setInterventionData({
            intervention: CalculatorEnum.Immunizations,
            value: { ...form.values, isValid: !!isValid },
          })
        );
        dispatch(calculatorActions.setSummaryData());

}

});

}, [form.values]);

  const onSwitchChange = (e: React.ChangeEvent<HTMLInputElement>) => {

    dispatch(
      calculatorActions.toggleInterventionsChecklistValue({
        key: InterventionsChecklistForm.Immunizations,
        value: e.target.checked,
      })
    );

},

   onNote = (noteName: string, noteAction: 'add' | 'edit' | 'delete') => {

    setNoteName(noteName);
    setNoteAction(noteAction);
    setIsNoteDialogOpen(true);

},

   onDialogNoteClose = () => {

    setIsNoteDialogOpen(false);

};

  return (
    <>
      <InterventionContainer
        disabled={!switchValue}
        onSubmit={form.handleSubmit}
        header={
          <InterventionHeader
            title="Immunizations"
            checked={switchValue}
            onChange={onSwitchChange}
          />
        }
        body={
          <InterventionBody
            description={
              <>
                Some HS Specialists discuss the benefits of immunizations for children as well as contact families to encourage them to attend their well-child visits. The following questions ask about the actions taken by caregivers in these situations during the 12-month date range.
              </>
            }
            header="Flu Vaccines"
            form={form}
            fields={fields}
            onNote={onNote}
          />
        }
        longTermBody={
          <InterventionBody
            header="Early Childhood Vaccination Series"
            form={form}
            fields={earlyChildhoodFields}
            onNote={onNote}
          />
        }
        footer={
          <ImmunizationInterventionFooter
            form={form}
            savingsText="Flu vaccine"
            description="Percent of Medicaid/CHIP-enrolled children who received the flu vaccine due to HS involvement"
            onNote={onNote}
          />
        }
        longTermFooter={
          <ImmunizationInterventionFooter
            hideSliders={true}
            form={form}
            savingsText="Early Childhood Vaccination Series"
            exclusiveDescription="Percent of Medicaid/CHIP-enrolled children who received the vaccination series due to HS"
            onNote={onNote}
          />
        }
        calculations={
          <ImmunizationInterventionCalculation
            form={form}
          />
        }
      />
      <InterventionFieldNoteDialog
        id={`${noteName}__${noteAction}-dialog`}
        name={noteName}
        value={form.values[noteName]}
        mode={noteAction}
        open={isNoteDialogOpen}
        onClose={onDialogNoteClose}
        form={form}
      />
    </>
  );

};

export default Immunizations;
